import { render, staticRenderFns } from "./Grafica3.vue?vue&type=template&id=12a5b7d6&"
import script from "./Grafica3.vue?vue&type=script&lang=js&"
export * from "./Grafica3.vue?vue&type=script&lang=js&"
import style0 from "./Grafica3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports